(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rk-vertrauen"] && !Shopify.designMode) return;
  try {
    
  /* Karussell auf Basis von nativem Scrollen: Pfeile, Fortschritt, "Mehr", optional Autoplay */
  if (!customElements.get('rk-gb-karussell')) {
    const rkGbWenigerBewegung = window.matchMedia('(prefers-reduced-motion: reduce)');

    customElements.define(
      'rk-gb-karussell',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.rk-gb__track');
          if (!this.track) return;

          this.balken = this.querySelector('.rk-gb__fortschritt-balken');
          this.aktualisieren = this.aktualisieren.bind(this);

          this.querySelector('[data-rk-zurueck]')?.addEventListener('click', () => this.blaettern(-1));
          this.querySelector('[data-rk-weiter]')?.addEventListener('click', () => this.blaettern(1));
          this.track.addEventListener('scroll', this.aktualisieren, { passive: true });

          this.querySelectorAll('.rk-gb__mehr').forEach((knopf) => {
            knopf.addEventListener('click', () => {
              const offen = knopf.closest('.rk-gb__karte').classList.toggle('ist-offen');
              knopf.setAttribute('aria-expanded', offen);
              knopf.textContent = offen ? 'Weniger' : 'Mehr';
            });
          });

          this.groessenBeobachter = new ResizeObserver(() => {
            this.aktualisieren();
            this.laengenPruefen();
          });
          this.groessenBeobachter.observe(this.track);

          this.classList.add('ist-bereit');
          this.aktualisieren();
          this.laengenPruefen();
          this.autoplayEinrichten();
        }

        disconnectedCallback() {
          clearInterval(this.takt);
          this.groessenBeobachter?.disconnect();
          this.sichtBeobachter?.disconnect();
        }

        schrittweite() {
          const slide = this.track.querySelector('.rk-gb__slide');
          const abstand = parseFloat(getComputedStyle(this.track).columnGap) || 0;
          return slide ? slide.getBoundingClientRect().width + abstand : this.track.clientWidth;
        }

        blaettern(richtung) {
          const max = this.track.scrollWidth - this.track.clientWidth;
          let ziel = this.track.scrollLeft + richtung * this.schrittweite();

          // Am Ende wieder von vorne beginnen (und umgekehrt)
          if (richtung > 0 && this.track.scrollLeft >= max - 4) ziel = 0;
          if (richtung < 0 && this.track.scrollLeft <= 4) ziel = max;

          this.track.scrollTo({ left: ziel, behavior: rkGbWenigerBewegung.matches ? 'auto' : 'smooth' });
        }

        aktualisieren() {
          const { scrollLeft, scrollWidth, clientWidth } = this.track;
          const keinScroll = scrollWidth <= clientWidth + 1;
          this.toggleAttribute('data-kein-scroll', keinScroll);
          if (!this.balken || keinScroll) return;

          this.balken.style.width = `${(clientWidth / scrollWidth) * 100}%`;
          this.balken.style.transform = `translateX(${(scrollLeft / clientWidth) * 100}%)`;
        }

        // "Mehr" nur dort zeigen, wo der Text tatsaechlich abgeschnitten ist
        laengenPruefen() {
          this.querySelectorAll('.rk-gb__karte:not(.ist-offen)').forEach((karte) => {
            const text = karte.querySelector('.rk-gb__text p');
            const knopf = karte.querySelector('.rk-gb__mehr');
            if (text && knopf) knopf.hidden = text.scrollHeight <= text.clientHeight + 2;
          });
        }

        autoplayEinrichten() {
          if (this.dataset.autoplay !== 'true' || rkGbWenigerBewegung.matches) return;

          const intervall = (parseInt(this.dataset.intervall, 10) || 6) * 1000;
          this.pausiert = false;
          this.sichtbar = false;

          const pausieren = () => (this.pausiert = true);
          const fortsetzen = () => (this.pausiert = false);
          this.addEventListener('mouseenter', pausieren);
          this.addEventListener('mouseleave', fortsetzen);
          this.addEventListener('focusin', pausieren);
          this.addEventListener('focusout', fortsetzen);
          // Wer selbst wischt, will in Ruhe lesen: Autoplay bleibt dann aus
          this.track.addEventListener('pointerdown', () => clearInterval(this.takt), { once: true });

          this.sichtBeobachter = new IntersectionObserver((eintraege) => {
            this.sichtbar = eintraege.some((eintrag) => eintrag.isIntersecting);
          });
          this.sichtBeobachter.observe(this);

          this.takt = setInterval(() => {
            if (!this.pausiert && this.sichtbar && !document.hidden) this.blaettern(1);
          }, intervall);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
